module.exports = __webpack_public_path__ + "img/google_play_white.834c176e.png";